export default "__VITE_ASSET__CEbr3pBY__"